export { LOCALE_CONFIG } from './lib/localization.model';
export { LocaleConfig } from './lib/localization.model';
export { LocalizationService } from './lib/localization.service';
export { provideLocalization } from './lib/provide-localization';
export {
  supportedLocaleData,
  getPreferredLocaleId,
  SUPPORTED_LOCALES,
  defaultLocale,
} from './lib/locale-data';
